import React, { useState, useEffect } from "react";
import "./EquipManager.css"; // Arquivo de estilização
import Conect from "../../../../../Api/Conect";
import moment from "moment";
import NotificationsAlert from "../../../../services/NotificationsAlert"

// Estado inicial do formulário
const initialFormState = {
    id: "",
    model: "",
    serial: "",
    chips_id: "",
};

const EquipManager = () => {
    // const navigate = useNavigate();
    const token = localStorage.getItem("rastoken");
    const [equipments, setEquipments] = useState([]);
    const [chips, setChips] = useState([]); // Lista de chips para seleção
    const [form, setForm] = useState(initialFormState);
    const [editing, setEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // Busca equipamentos e chips ao montar o componente
    useEffect(() => {
        fetchEquipments();
        fetchChipsList();
        // eslint-disable-next-line
    }, []);

    // Função para buscar a lista de equipamentos
    const fetchEquipments = async () => {
        try {
            const { data: equipData } = await Conect.get(`/ZXF1aXBsaXN0${token}`);
            setEquipments(equipData.data);
        } catch (error) {
            console.error("Erro ao buscar equipamentos:", error);
        }
    };

    // Função para buscar a lista de chips
    const fetchChipsList = async () => {
        try {
            const { data: chipsData } = await Conect.get(`/Y2hpcHNsaXN0${token}`);
            setChips(chipsData.data);
        } catch (error) {
            console.error("Erro ao buscar chips:", error);
        }
    };

    // Função para combinar dados de equipamento com chips
    const mergeEquipWithChips = (equipments, chips) => {
        return equipments.map((equip) => ({
            ...equip,
            chip: chips.find((chip) => chip.id === equip.chips_id)?.phone_number || "Desconhecido",
        }));
    };

    // Função para lidar com a mudança de input do formulário
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prevForm) => ({ ...prevForm, [name]: value }));
    };

    // Função para enviar os dados de criação ou edição de equipamento
    const handleSubmit = async () => {
        try {
            let res
            if (editing) {
                res = await Conect.put(`/ZXF1aXB1cGRhdGU=${token}`, form); // Rota para atualizar equipamento
            } else {
                res = await Conect.post(`/ZXF1aXBjcmVhdA==${token}`, form); // Rota para criar equipamento
            }
            if (res.data?.erro) {
                NotificationsAlert("warning", "Atenção", res.data.msg)
            } else {
                NotificationsAlert("default", "Sucesso!", res.data.msg)
            }
            fetchEquipments();
            closeModal();
        } catch (error) {
            console.error(`Erro ao ${editing ? "atualizar" : "criar"} equipamento:`, error);
        }
    };

    // Função para excluir um equipamento
    const handleDeleteEquip = async (id) => {
        try {
            await Conect.delete(`/ZGVsZXRlZXF1aXA=${token}`, { data: { id } }); // Rota para deletar equipamento
            fetchEquipments();
        } catch (error) {
            console.error("Erro ao remover equipamento:", error);
        }
    };

    // Função para abrir o modal com dados do equipamento (se houver) para edição ou vazio para criação
    const openModal = (equip = null) => {
        setForm(equip ? equip : initialFormState);
        setEditing(!!equip);
        setShowModal(true);
    };

    // Função para fechar o modal
    const closeModal = () => setShowModal(false);

    return (
        <div className="equip-manager">
            <h2>Gerenciamento de Equipamentos</h2>
            <button className="equip-btns-block" onClick={() => openModal()}>Adicionar Equipamento</button>

            <table className="equip-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Modelo</th>
                        <th>Serial</th>
                        <th>Chip</th>
                        <th>Atualizado</th>
                        <th>Criado</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {mergeEquipWithChips(equipments, chips).map((equip) => (
                        <tr key={equip.id}>
                            <td>{equip.id}</td>
                            <td>{equip.model}</td>
                            <td>{equip.serial}</td>
                            <td>{equip.chip}</td>
                            <td>{equip.updated_at ? moment(equip.updated_at).format("DD/MM/YYYY HH:mm:ss") : "--"}</td>
                            <td>{moment(equip.created_at).format("DD/MM/YYYY HH:mm:ss")}</td>
                            <td>
                                <button style={{ marginLeft: '2%', marginRight: '3%' }} className="equip-btns-block" onClick={() => openModal(equip)}>Editar</button>
                                <button className="equip-btns-block" onClick={() => handleDeleteEquip(equip.id)}>Remover</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal */}
            {showModal && (
                <div className="equip-modal">
                    <div className="equip-modal-content">
                        <h3>{editing ? "Editar Equipamento" : "Adicionar Equipamento"}</h3>
                        <input
                            type="text"
                            name="model"
                            placeholder="Modelo"
                            value={form.model}
                            onChange={handleInputChange}
                        />
                        <input
                            type="text"
                            name="serial"
                            placeholder="Serial"
                            value={form.serial}
                            onChange={handleInputChange}
                        />
                        <select
                            name="chips_id"
                            value={form.chips_id}
                            onChange={handleInputChange}
                        >
                            <option value="">Selecione um Chip</option>
                            {chips.map((chip) => (
                                <option key={chip.id} value={chip.id}>
                                    {chip.phone_number}
                                </option>
                            ))}
                        </select>
                        <div className="equip-modal-actions">
                            <button className="equip-btns-block" onClick={handleSubmit}>{editing ? "Atualizar" : "Adicionar"} Equipamento</button>
                            <button className="equip-btns-block" onClick={closeModal}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EquipManager;
